import React, { useCallback } from 'react';
import { useParams } from 'react-router-dom';
import { ReportPage } from '../reports/ReportPage';
import { loadReport } from '../reports/reportLoaders';
import type { TemplateContext } from '../reports/mustache';

/**
 * Hair report route — a shareable preview of the sheet.
 *
 * Not the primary way to get a PDF: the button on the result screen exports
 * directly without coming here. This route exists so a report can be opened
 * from a link, and it renders the same template the export produces.
 */
export default function HairAnalysisPDFPage(): React.JSX.Element {
  const { id } = useParams<{ id: string }>();

  const load = useCallback(async (): Promise<TemplateContext | null> => {
    if (!id) return null;
    const report = await loadReport('hair', id);
    return report?.viewModel ?? null;
  }, [id]);

  return (
    <ReportPage
      kind="hair"
      load={load}
      title={`kivo-hair-report-${(id ?? '').slice(0, 8).toUpperCase()}`}
    />
  );
}
